import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ShippingBox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.973 6.18H30.98c-.7 0-1.299.4-1.699 1l-3.497 5.895-3.498-5.896c-.4-.6-1-1-1.7-1H2c-1.1 0-1.999.9-1.999 2 0 .3.1.699.3.999l3.398 5.796V36.66c0 1.1.9 1.999 1.998 1.999h32.68c1.099 0 1.998-.9 1.998-1.999V14.974l3.398-5.796c.7-1.4-.3-2.998-1.799-2.998ZM1.7 8.278c-.1-.2 0-.4.3-.4h18.688c.1 0 .2.1.3.2l3.497 5.897H4.997L1.699 8.278ZM24.984 36.86H5.696c-.2 0-.3-.1-.3-.3V15.574h19.588V36.86Zm13.591-.3c0 .2-.1.3-.3.3H26.684V15.574h11.992V36.56h-.1Zm3.698-28.282-3.298 5.597H27.183l3.497-5.896c.1-.1.2-.2.3-.2h10.993c.3.1.4.3.3.5Z"
  }));
});
ShippingBox.displayName = 'ShippingBox';
ShippingBox.defaultProps = {
  'aria-label': 'ShippingBox'
};
export default ShippingBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ShippingBox.js
// module id = 3284
// module chunks = 11